import React from 'react';
import { ChefHat, Shirt, CheckCircle } from 'lucide-react';

const products = [
  "Chef Coats (Black & White)",
  "Half Apron & 3/4th Apron",
  "Restaurant Service Vests",
  "Chef Shoes",
  "Plain Chef Pants",
  "Bandana Cap, Chef Cap & Round Cap",
];

const RestaurantChefSection = () => {
  return (
    <section id="restaurant-chef" className="py-20 bg-slate-50" data-testid="restaurant-chef-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center mb-4">
            <ChefHat className="h-8 w-8 text-blue-900 mr-2" />
            <span className="text-blue-900 font-semibold text-lg">Restaurant & Hospitality</span>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Restaurant & Chef Uniforms</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Complete uniform solutions for restaurants, cafes & hotels — from chef coats to service wear
          </p>
        </div>

        {/* Content Grid */}
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          {/* Catalog Image */}
          <div className="rounded-2xl overflow-hidden shadow-lg border border-gray-200 flex justify-center bg-slate-50 p-4">
            <img
              src="https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/bhn7sjnd_WhatsApp%20Image%202026-03-16%20at%205.12.11%20AM.jpeg"
              alt="Alf Uniform - Restaurant Chef Uniform Collection"
              className="max-w-xl w-full h-auto rounded-xl object-contain"
              data-testid="restaurant-chef-image"
            />
          </div>

          {/* Product Details */}
          <div>
            <div className="inline-flex items-center gap-2 bg-green-100 text-green-800 px-4 py-1.5 rounded-full text-sm font-semibold mb-6">
              <Shirt className="h-4 w-4" />
              Ready Stock Available
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-3">Complete Chef & Service Collection</h3>
            <p className="text-gray-600 mb-6">
              Available for restaurants, cafes & hotels. Custom logo embroidery on all items. Bulk orders welcome.
            </p>

            {/* Product List */}
            <ul className="space-y-3 mb-8">
              {products.map((item, i) => (
                <li key={i} className="flex items-center gap-3">
                  <CheckCircle className="h-5 w-5 text-blue-900 flex-shrink-0" />
                  <span className="text-gray-700 font-medium">{item}</span>
                </li>
              ))}
            </ul>

            {/* CTA */}
            <a
              href="https://wa.me/96566902952?text=Hi%2C%20I%E2%80%99m%20interested%20in%20Restaurant%20%26%20Chef%20Uniforms"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="restaurant-chef-cta"
              className="inline-flex items-center gap-2 bg-blue-900 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-800 transition-colors"
            >
              Get a Quote
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RestaurantChefSection;
